import React, { useState, useEffect, keyframes } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  IconButton,
  Grid,
  Avatar,
  Tabs,
  Tab,
  useTheme,
  Snackbar,
  Link,
  Dialog,
  Divider,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PersonIcon from "@mui/icons-material/Person";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import Secondhaldcontent from "./Secondhaldcontent";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { baseapi } from "../Environmentalurl";
import {
  ApplicationType,
  entity_id,
  locationGeo,
  Platform,
} from "../Utils/Const";
import ComingSoon from "../Utils/ComingSoon";
import { useContext } from "react";
import { WalletFocusContext } from "./WalletFocusContext";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import useMediaQuery from "@mui/material/useMediaQuery";
import api from "../Utils/Api";

function useIPAddress() {
  return "127.0.0.1";
}

function formatIndianNumber(num) {
  if (!num) return 0;
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function Dashboardcontent({ billPaymentRef, walletRef }) {
  const [tab, setTab] = useState(0);
  const [user, setUser] = useState({});
  const [maskedCard, setMaskedCard] = useState("");
  const [subWallet, setSubWallet] = useState(null);
  const [openComingSoon, setOpenComingSoon] = useState(false);
  const ip = useIPAddress();
  const [isKycDone, setIsKycDone] = useState(
    sessionStorage.getItem("Is_KYC_Done") || "2",
  );
  const [openPopup, setOpenPopup] = useState(false);
  const [showBalance, setShowBalance] = useState(() => {
    const saved = localStorage.getItem("showBalance");
    return saved === "true";
  });
  const [transactions, setTransactions] = useState([]);
  const [loadingTransactions, setLoadingTransactions] = useState(false);
  const [copied, setCopied] = useState(false);
  const [openLedgerInfo, setOpenLedgerInfo] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleWalletServiceClick = (callback) => {
    if (isKycDone === "2") {
      setOpenPopup(true);
    } else {
      callback();
    }
  };

  const handleTabChange = (e, newValue) => {
    setTab(newValue);
  };

  const navigate = useNavigate();

  const handleloadmoney = () => {
    navigate("/dashboard/loadmoney");
  };

  const handlesendmoney = () => {
  navigate("/dashboard/transfertobank");
};

  const handleupipay = () => {
    navigate("/Dashboard/walletservice/upipay");
  };

  const handlebanktransfer = () => {
    navigate("/Dashboard/BanktransferLayout");
  };

  const handleCardClick = async (service) => {
    if (service.route) {
      navigate(service.route);
      return;
    }

    if (service.action === "upgradeWallet") {
      try {
        setLoading(true);

        const mobile = sessionStorage.getItem("mobileNumber");

        if (!mobile) {
          alert("Mobile not found");
          setLoading(false);
          return;
        }

        const res = await api.post(
          "https://staging.transactionanalysts.com:444/VCIP/vcip/AccountHolder/KycStatus",
          {
            mobileNumber: mobile,
            entityID: 65,
            platformId: 1,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "X-Company-Code": "TA001",
            },
          },
        );

        console.log("KYC Status Response:", res.data);
        const { resCode, resDesc } = res.data;

        if (resCode === "101") {
          console.log("👉 Status 101 → Start KYC flow");

          const response = await api.post(
            "https://esetu.transactionanalysts.com/subaua/api/generateTransactionId",
            {
              encData: "20JoCsYqpSHbkYYja2FM9b8Rwk9nnHCYe0T5O6jPNZg=",
              agencyCode: "TESSA03240248",
              callbackUrl:
                "https://taapp.transactionanalysts.com:8089/apiwallet/api/v1/services/vciptransidcallbackurl/callbackurl",
            },
            {
              headers: {
                Authorization: "Basic aGFwcGVuaW5nOlBhc3N3b3JkQDEyMw==",
                "Content-Type": "application/json",
              },
            },
          );

          console.log("FULL TXN RESPONSE => ", response.data);

          // CHECK ALL POSSIBLE KEYS
          const txnId =
            response?.data?.txnId ||
            response?.data?.transactionId ||
            response?.data?.responseData?.txnId ||
            response?.data?.responseData?.transactionId ||
            response?.data?.data?.txnId ||
            response?.data?.data?.transactionId;

          console.log("TXN ID => ", txnId);

          if (txnId && txnId !== "undefined" && txnId !== "null") {
            localStorage.setItem("txnId", txnId);

            localStorage.setItem("kycFlow", "PAN_PENDING");

            localStorage.setItem("kycStep", "AFTER_ESETU");

            window.location.href = `https://esetu.transactionanalysts.com/goEsetu/${txnId}`;
          } else {
            console.log("INVALID RESPONSE => ", response.data);

            alert("Transaction ID not received from API");
          }

          setLoading(false);
          return;
        }

        if (resCode === "102") {
          console.log("👉 KYC already in progress");

          const mobile = sessionStorage.getItem("mobileNumber");

          const res2 = await axios.get(
            `https://staging.transactionanalysts.com:444/VCIP/vcip/AccountHolder/get-by-mobile?mobileNumber=${mobile}`,
            {
              headers: {
                "X-Company-Code": "TA001",
              },
            },
          );

          console.log("User Data:", res2.data);

          if (res2.data?.resCode === "000") {
            navigate("/kyc-userdetails", {
              state: res2.data.data[0],
            });
          } else {
            alert(res2.data?.resDesc || "Failed to fetch data");
          }

          setLoading(false);
          return;
        }

        if (["201", "202", "203"].includes(resCode)) {
          alert(resDesc || "KYC Rejected ❌");
          setLoading(false);
          return;
        }

        alert(resDesc || "Unexpected response ❌");
        setLoading(false);
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong ❌");
        setLoading(false);
      }
    }
  };

  const checkKycStatus = async (txnId) => {
    try {
      setLoading(true);

      const response = await api.post(
        `https://esetu.transactionanalysts.com/subaua/api/generateKyc/${txnId}`,
        {
          encData: "20JoCsYqpSHbkYYja2FM9b8Rwk9nnHCYe0T5O6jPNZg=",
          agencyCode: "TESSA03240248",
        },
        {
          headers: {
            Authorization: "Basic aGFwcGVuaW5nOlBhc3N3b3JkQDEyMw==",
            "Content-Type": "application/json",
          },
        },
      );

      console.log("KYC RESPONSE:", response.data);

      if (response.data?.responseData?.statusMessage === "success") {
        alert("KYC Completed Successfully");
        const userData = response.data.responseData;
        console.log(userData);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("KYC API Error", error);
    }
  };

  useEffect(() => {
    const txnId = localStorage.getItem("txnId");
    if (txnId) {
      checkKycStatus(txnId);
    }
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
  };

  const banners = [
    "/Assets/banner1.png",
    "/Assets/banner2.jpg",
    "/Assets/banner3.jpg",
  ];

  const [cardData, setCardData] = useState(null);
  const mobileNumber = JSON.parse(
    sessionStorage.getItem("mobileNumber") || "null",
  );

  useEffect(() => {
    const fetchCardStatus = async () => {
      try {
        const response = await api.post(`${baseapi}/getcardstatus`, {
          ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
          Mobilenumber: mobileNumber,
          ReferenceNumber: "511512020945",
          Platform: Platform,
          ApplicationType: ApplicationType,
          EntityID: entity_id,
          GeoLocation: locationGeo,
          MachineID: ip,
        });

        setCardData(response.data);
      } catch (error) {
        console.error("Error fetching card status:", error);
      }
    };

    fetchCardStatus();
  }, []);

  const location = useLocation();

  useEffect(() => {
    const fetchBalanceEnquiry = async () => {
      try {
        const payload = {
          ApplicationType: ApplicationType,
          EntityID: entity_id,
          GeoLocation: locationGeo,
          MachineID: ip,
          Mobilenumber: sessionStorage.getItem("mobileNumber"),
          Platform: Platform,
          ReqType: "Jan_Aadhaar_eWallet_Balance_Enquiry",
          SessionID: sessionStorage.getItem("SessionID") || "",
        };

        const response = await api.post(
          `${baseapi}/JanAadhaareWalletBalanceEnquiry`,
          payload,
        );

        if (response.data.Response_Code === "1000") {
          const walletData = response.data.SubWallets?.[0];
          setUser((prev) => ({
            ...prev,
            Balance: response.data.Balance,
            LedgerBalance: response.data.LedgerBalance,
            NameOnCard: prev.NameOnCard || "User Name",
            UPIVPA: prev.UPIVPA || "user@upi",
            Is_KYC_Done: prev.Is_KYC_Done || "1",
          }));
          setSubWallet(walletData);
        } else {
          console.error("Balance Enquiry Failed:", response.data.Message);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };

    fetchBalanceEnquiry();
  }, [location.search]);

  useEffect(() => {
    const fetchRecentTransactions = async () => {
      setLoadingTransactions(true);
      try {
        const response = await api.post(
          `${baseapi}/JanAadhaarAccountStatement`,
          {
            ReqType: "Jan_Aadhaar_Account_Statment",
            Mobilenumber: sessionStorage.getItem("mobileNumber"),
            MachineID: ip,
            Platform: Platform,
            ApplicationType: ApplicationType,
            GeoLocation: locationGeo,
            EntityID: entity_id,
          },
        );

        if (response.data.Response_Code === "1000") {
          setTransactions(response.data.Info?.Table || []);
        } else {
          setTransactions([]);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setTransactions([]);
      } finally {
        setLoadingTransactions(false);
      }
    };

    fetchRecentTransactions();
  }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const formatDate = (dateString) => {
    const d = new Date(dateString);
    const day = d.toLocaleString("en-IN", { day: "2-digit" });
    const month = d.toLocaleString("en-IN", { month: "short" });
    const year = d.getFullYear();
    const time = d.toLocaleString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${day} ${month} ${year}, ${time}`;
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromHeader = params.get("tab");
    if (tabFromHeader === "wallet") {
      setTab(0);
    }
  }, [location.search]);

  const { highlightWallet, setHighlightWallet } =
    useContext(WalletFocusContext);

  useEffect(() => {
    if (highlightWallet) {
      const t = setTimeout(() => setHighlightWallet(false), 2000);
      return () => clearTimeout(t);
    }
  }, [highlightWallet]);

  const rupayRefNo = useSelector((state) => state.auth.rupayRefNo);
  console.log("rupayRefNo" + rupayRefNo);

  const Mobilenumber = JSON.parse(
    sessionStorage.getItem("mobileNumber") || "null",
  );
  const SessionID = JSON.parse(sessionStorage.getItem("SessionID") || "null");

  useEffect(() => {
    if (!rupayRefNo) return;

    const fetchCardStatusWithToken = async () => {
      try {
        // ✅ Get token from sessionStorage
        const token =
          sessionStorage.getItem("token") ||
          sessionStorage.getItem("authToken") ||
          sessionStorage.getItem("jwtToken") ||
          sessionStorage.getItem("accessToken") ||
          "";

        const payload = {
          ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
          Mobilenumber: Mobilenumber,
          ReferenceNumber: rupayRefNo,
          Platform: Platform,
          ApplicationType: ApplicationType,
          EntityID: entity_id,
          GeoLocation: locationGeo,
          MachineID: ip,
          SessionID: SessionID,
        };

        // ✅ Use api instance (has interceptor) with explicit token header
        const res = await api.post(`${baseapi}/getcardstatus`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.data.Response_Code === "4001") {
          setMaskedCard(res.data.MaskedCard);
        }
      } catch (err) {
        console.log("getcardstatus error:", err);
      }
    };

    fetchCardStatusWithToken();
  }, [rupayRefNo]);

  const formatMaskedCard = (card) => {
    if (!card || card.length < 8) {
      return "●●●● ●●●● ●●●● ●●●●";
    }
    const last4 = card.slice(-4);
    return `●●●● ●●●● ●●●● ${last4}`;
  };

  const formatDateOnly = (dateString) => {
    if (!dateString) return "—";
    const d = new Date(dateString);
    return d.toLocaleDateString("en-GB");
  };

  useEffect(() => {
    if (location.state?.focusWallet) {
      setHighlightWallet(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const pulseGlow = {
    "@keyframes pulseGlow": {
      "0%": { boxShadow: "0 0 0 0 rgba(77,182,77,0.45)" },
      "70%": { boxShadow: "0 0 0 10px rgba(77,182,77,0)" },
      "100%": { boxShadow: "0 0 0 0 rgba(77,182,77,0)" },
    },
  };

  useEffect(() => {
    if (highlightWallet) {
      const timer = setTimeout(() => {
        setHighlightWallet(false);
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [highlightWallet]);

  return (
    <>
      {/* 🔹 Top Balance and Info Boxes */}
      <Box sx={{bgcolor:"#f8fafc",px:{xs:2,sm:3,md:4},py:{xs:2,md:3}}}>
      <Grid container spacing={3}>
        <Grid container spacing={3}>
          {isMobile ? (
            <Grid item xs={12}>
              <Box
                sx={{
                  background: "linear-gradient(135deg,#15803d 0%,#16a34a 40%,#22c55e 100%)",
                  borderRadius: 3, p: 2, color: "white",
                  boxShadow: "0 8px 32px rgba(22,163,74,0.25)",
                }}
              >
                <Typography sx={{fontSize:"11px",opacity:0.8}}>Wallet Balance</Typography>
                <Typography sx={{fontSize:"24px",fontWeight:800}}>
                  {showBalance ? `₹ ${formatIndianNumber(user?.Balance)}` : "₹ ••••••"}
                </Typography>
                <Divider sx={{my:1,borderColor:"rgba(255,255,255,0.2)"}}/>
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <Typography sx={{fontSize:"11px",opacity:0.8}}>
                    Ledger Balance:
                    <Box component="span" sx={{fontWeight:700,ml:0.5}}>
                      ₹{user?.LedgerBalance}
                    </Box>
                  </Typography>
                  <IconButton size="small" sx={{ px: 5 }}>
                    <RemoveRedEyeIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              </Box>
            </Grid>
          ) : (
            <>
              <Grid size={{ md: 2 }} item xs={12} sm={6} md={6}>
                <Box
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "12px",
                    p: { xs: 1.5, md: 2 },
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#6b7280",
                      fontWeight: 500,
                      fontSize: { xs: "14px", md: "18px" },
                      textAlign: "center",
                    }}
                  >
                    Wallet Balance
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", md: "20px" },
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                  >
                    ₹{user?.Balance}
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, md: 3, sm: 3 }} item xs={12} sm={6} md={3}>
                <Box
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "12px",
                    p: 2,
                    minWidth: 300,
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#6b7280",
                        fontWeight: 500,
                        fontSize: "20px",
                      }}
                    >
                      Wallet Ledger Balance
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => setOpenLedgerInfo(true)}
                      sx={{
                        color: isDark ? "#9bb3c9" : "#6c7a9c",
                        "&:hover": { color: "#16a34a" },
                      }}
                    >
                      <RemoveRedEyeIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "20px",
                      color: isDark ? "#ffffff" : "#000000",
                      textAlign: "center",
                      mr: 5,
                    }}
                  >
                    ₹{user?.LedgerBalance}
                  </Typography>
                </Box>
              </Grid>
            </>
          )}

          <Grid ref={walletRef} size={{ xs: 12, md: 4 }} item xs={12} md={4}>
            {isKycDone === "2" ? (
              <Box
                sx={{
                  backgroundColor: "#ffd966",
                  borderRadius: "10px",
                  p: { xs: "10px 12px", sm: "12px 16px" },
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  gap: { xs: 1, sm: 2 },
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <WarningAmberIcon
                    sx={{
                      color: "#000",
                      mr: 1,
                      mb: 1,
                      fontSize: { xs: 18, sm: 22 },
                    }}
                  />
                  <Typography
                    sx={{
                      color: "#000",
                      fontWeight: 500,
                      fontSize: { xs: "11px", sm: "13px", md: "14px" },
                    }}
                  >
                    Full KYC Status: Limited to ₹2,00,000 Transactions
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor: "#000",
                    color: "#fff",
                    textTransform: "none",
                    fontSize: { xs: "9px", sm: "11px" },
                    px: 3,
                    py: 3,
                    height: "24px",
                    minHeight: "24px",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => handleCardClick({ action: "upgradeWallet" })}
                >
                  Activate Full KYC
                </Button>
              </Box>
            ) : (
              <Box
                sx={{
                  backgroundColor: "#d4edda",
                  borderRadius: "10px",
                  p: { xs: "10px 12px", sm: "12px 16px" },
                  display: "flex",
                  alignItems: "left",
                  textAlign: { xs: "left", sm: "left" },
                  height: "100%",
                }}
              >
                <Typography
                  sx={{
                    color: "#155724",
                    fontWeight: 600,
                    fontSize: { xs: "11px", sm: "13px", md: "14px" },
                  }}
                >
                  ✅ You are successfully done with Full KYC. Now you can avail
                  all services.
                </Typography>
              </Box>
            )}
          </Grid>

          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <Box
              sx={{
                backgroundColor: isDark ? "#44573e" : "#93a98dff",
                borderRadius: "10px",
                px: { xs: 1.2, sm: 2 },
                py: { xs: 1, sm: 1.5 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: { xs: 0.3, sm: 0.5 },
                width: { xs: "100%", md: 350 },
                minHeight: { xs: 70, sm: 90 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "11px", sm: "14px" },
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <span style={{ color: "white", fontWeight: 300 }}>
                    Name:
                  </span>{" "}
                  <span style={{ fontWeight: 600, color: "white" }}>
                    {user?.NameOnCard}
                  </span>
                </Typography>
                <PersonIcon
                  sx={{ fontSize: { xs: 14, sm: 16 }, color: "#ffcc00" }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "11px", sm: "14px" },
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <span style={{ color: "white", fontWeight: 300 }}>
                    UPI:
                  </span>{" "}
                  <span style={{ fontWeight: 600, color: "white" }}>
                    {user?.UPIVPA}
                  </span>
                </Typography>
                <ContentCopyIcon
                  onClick={() => {
                    navigator.clipboard.writeText(user?.UPIVPA || "");
                    setCopied(true);
                  }}
                  sx={{
                    fontSize: { xs: 14, sm: 16 },
                    color: "white",
                    cursor: "pointer",
                    "&:active": { transform: "scale(0.9)" },
                  }}
                />
              </Box>

              <Snackbar
                open={copied}
                autoHideDuration={2000}
                onClose={() => setCopied(false)}
                message="UPI ID copied!"
                ContentProps={{
                  sx: {
                    backgroundColor: isDark ? "#1e2a44" : "#000000",
                    color: "white",
                    borderRadius: "8px",
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      </Box>

      {/* 🔹 Main Section */}
      <Grid container spacing={4} sx={{ px: 2 }}>
        <Grid size={{ xs: 12, md: 8 }} item xs={12} md={8}>
          <Card
            sx={{
              backgroundColor: "white",
              borderRadius: 3,
              boxShadow: "none",
              p: 3,
              border: "1px solid rgba(90, 126, 173, 0.49)",
            }}
          >
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
                <Box>
                  <Box display="flex" alignItems="center" mb={{ xs: 1, md: 2 }}>
                    <img
                      src="/Assets/atm_card.png"
                      height={isMobile ? 18 : 26}
                      alt="card"
                    />
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        ml: 1,
                        color: "#111827",
                        fontSize: { xs: "14px", md: "18px" },
                      }}
                    >
                      My Wallet
                    </Typography>
                  </Box>

                  <motion.div
                    initial={{ x: -200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.6 }}
                  >
                    <Card
                      sx={{
                        borderRadius: 2,
                        background:
                          "linear-gradient(45deg, #0597FF 0%, #18B4A2 100%)",
                        color: "#fff",
                        p: { xs: 1.5, md: 2.5 },
                        minHeight: { xs: 140, md: "auto" },
                      }}
                    >
                      <Typography
                        sx={{
                          opacity: 0.9,
                          fontSize: { xs: "11px", md: "14px" },
                          mb: 0.5,
                        }}
                      >
                        Wallet Balance
                      </Typography>

                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: { xs: "18px", md: "28px" },
                            textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
                          }}
                        >
                          {showBalance
                            ? `₹${formatIndianNumber(user?.Balance)}`
                            : "******"}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => setShowBalance(!showBalance)}
                          sx={{ p: { xs: 0.5, md: 1 } }}
                        >
                          <VisibilityIcon
                            sx={{
                              color: "#fff",
                              fontSize: { xs: 18, md: 22 },
                            }}
                          />
                        </IconButton>
                      </Box>

                      <Typography
                        sx={{
                          mt: 0.5,
                          opacity: 0.8,
                          fontSize: { xs: "10px", md: "13px" },
                          fontWeight: 500,
                        }}
                      >
                        Status:{" "}
                        <span style={{ fontWeight: "600", color: "#fff" }}>
                          {user?.Is_KYC_Done === 2
                            ? "Low KYC"
                            : user?.Is_KYC_Done === 1
                              ? "Full KYC"
                              : "Unknown"}
                        </span>
                      </Typography>

                      <Typography
                        sx={{ mt: 0.5, fontSize: { xs: "10px", md: "13px" } }}
                      >
                        {user?.Is_KYC_Done === 2
                          ? "Limit: ₹10K/day"
                          : "Max Balance: ₹2L"}
                      </Typography>

                      <Box
                        display="flex"
                        mt={{ xs: 1, md: 2 }}
                        gap={{ xs: 0.5, md: 1 }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#000",
                            color: "#fff",
                            textTransform: "none",
                            fontSize: { xs: "10px", md: "14px" },
                            px: { xs: 1.5, md: 2.5 },
                            py: { xs: 0.5, md: 1 },
                            minWidth: "auto",
                          }}
                          onClick={handleloadmoney}
                        >
                          ➕ Add Money
                        </Button>

                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#fff",
                            color: "#000",
                            textTransform: "none",
                            fontSize: { xs: "10px", md: "14px" },
                            px: { xs: 1.5, md: 2.5 },
                            py: { xs: 0.5, md: 1 },
                            minWidth: "auto",
                          }}
                            onClick={handlesendmoney}
                        >
                          ➤ Send Money
                        </Button>
                      </Box>
                    </Card>
                  </motion.div>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6}>
                <Box>
                  {isKycDone === "2" && (
                    <Slider {...settings}>
                      {banners.map((banner, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            height: { xs: 140, sm: 180, md: 220 },
                            borderRadius: 2,
                            overflow: "hidden",
                            mt: { xs: 2, md: 6 },
                          }}
                        >
                          <img
                            src={banner}
                            alt={`banner${idx}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                            }}
                          />
                        </Box>
                      ))}
                    </Slider>
                  )}

                  {isKycDone === "1" && (
                    <>
                      <Box display="flex" alignItems="center" mt={1}>
                        <Avatar
                          src="/Assets/rupay_logo.png"
                          sx={{
                            width: { xs: 22, md: 32 },
                            height: { xs: 22, md: 32 },
                            p: 0.3,
                            backgroundColor: "#fff",
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            ml: 1,
                            color: "#111827",
                            fontSize: { xs: "14px", md: "18px" },
                            mb: { md: 1 },
                          }}
                        >
                          RuPay Card
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          position: "relative",
                          height: { xs: 140, sm: 180, md: 220 },
                          borderRadius: 2,
                          p: { xs: 1.5, md: 3 },
                          color: "#fff",
                          background:
                            "linear-gradient(135deg, #3C4DD0 0%, #5922DF 100%)",
                          boxShadow: "0px 5px 20px rgba(0,0,0,0.3)",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          component="img"
                          src="/Assets/tacircle_logo.png"
                          sx={{
                            position: "absolute",
                            top: { xs: 10, md: 20 },
                            left: { xs: 10, md: 20 },
                            width: { xs: 22, md: 35 },
                            height: { xs: 22, md: 35 },
                          }}
                        />
                        <Box
                          component="img"
                          src="/Assets/ta_walletlogo.png"
                          sx={{
                            position: "absolute",
                            top: { xs: 10, md: 20 },
                            right: { xs: 10, md: 20 },
                            width: { xs: 25, md: 40 },
                            height: { xs: 25, md: 40 },
                          }}
                        />
                        <Box
                          component="img"
                          src="/Assets/chipimg.png"
                          sx={{
                            position: "absolute",
                            top: { xs: 45, md: 70 },
                            left: { xs: 15, md: 35 },
                            width: { xs: 25, md: 45 },
                          }}
                        />
                        <Box
                          component="img"
                          src="/Assets/contactless.png"
                          sx={{
                            position: "absolute",
                            top: { xs: 50, md: 85 },
                            right: { xs: 15, md: 35 },
                            width: { xs: 18, md: 30 },
                          }}
                        />
                        <Typography
                          sx={{
                            letterSpacing: 2,
                            fontWeight: "bold",
                            fontSize: { xs: "12px", md: "18px" },
                            position: "absolute",
                            bottom: { xs: 35, md: 55 },
                            left: { xs: 15, md: 35 },
                          }}
                        >
                          {formatMaskedCard(maskedCard)}
                        </Typography>
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: { xs: 8, md: 20 },
                            left: { xs: 10, md: 25 },
                            right: { xs: 10, md: 25 },
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Link
                            component={RouterLink}
                            to="/dashboard/rupaycard"
                            underline="always"
                            sx={{
                              color: "#fff",
                              fontSize: { xs: "10px", md: "14px" },
                            }}
                          >
                            Know more
                          </Link>
                          <Box
                            component="img"
                            src="/Assets/rupay_ta.png"
                            sx={{ width: { xs: 50, md: 90 } }}
                          />
                        </Box>
                      </Box>
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {/* RIGHT SIDE — Wallet Service */}
        <Grid ref={walletRef} size={{ xs: 12, md: 4 }} item xs={12} md={4}>
          {highlightWallet && (
            <Box
              sx={{
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "6px",
                borderRadius: "6px 0 0 6px",
                background: "linear-gradient(180deg, #16a34a, #22c55e)",
              }}
            />
          )}
          <Card
            sx={{
              position: "relative",
              backgroundColor: "white",
              borderRadius: 2,
              height: "100%",
              p: { xs: 1, md: 2 },
              border: "1px solid #f0f0f0",
              transition: "all 0.4s ease",
            }}
          >
            <Tabs
              value={tab}
              onChange={(e, v) => setTab(v)}
              textColor="inherit"
              TabIndicatorProps={{ style: { backgroundColor: "#16a34a", height: 3 } }}
              sx={{
                borderBottom: "1px solid gray",
                minHeight: { xs: 32, md: 48 },
                "& .MuiTab-root": {
                  fontSize: { xs: "10px", md: "14px" },
                  minHeight: { xs: 32, md: 48 },
                  padding: { xs: "4px 6px", md: "12px" },
                },
              }}
            >
              <Tab label="Wallet Services" />
              <Tab label="Transactions" />
            </Tabs>

            <Box p={2} hidden={tab !== 0} height={140}>
              <Grid container spacing={1}>
                {[
                  {
                    label: "UPI Pay",
                    icon: "/Assets/bhim.png",
                    path: "/dashboard/upi",
                  },
                  {
                    label: "Add Money",
                    icon: "/Assets/add_payment.png",
                    path: "/dashboard/loadmoney",
                  },
                  {
                    label: "Bank Transfer",
                    icon: "/Assets/bank_transfer.png",
                    path: "/dashboard/transfertobank",
                  },
                  {
                    label: "Wallet Transfer",
                    icon: "/Assets/wallet.png",
                    path: "/dashboard/wallettransfer",
                  },
                ].map((item, idx) => (
                  <Grid
                    size={{ xs: 6, sm: 3, md: 6 }}
                    item
                    xs={6}
                    sm={3}
                    key={idx}
                    bgcolor={isDark ? "" : "white"}
                  >
                    <Button
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        if (item.label === "UPI Pay") {
                          setOpenComingSoon(true);
                        } else {
                          navigate(item.path);
                        }
                      }}
                      sx={{
                        justifyContent: "flex-start",
                        fontSize: { xs: "10px", md: "14px" },
                        padding: { xs: "5px 6px", md: "8px 10px" },
                        borderRadius: "5px",
                        color: "#111827",
                        bgcolor: isDark ? "#2c3b4dff" : "transparent",
                        minHeight: { xs: 36, md: 68 },
                      }}
                    >
                      <Avatar
                        sx={{
                          width: { xs: 22, md: 30 },
                          height: { xs: 22, md: 30 },
                          mr: 0.8,
                          bgcolor: "#fff",
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.label}
                          style={{ width: 20, height: 20 }}
                        />
                      </Avatar>
                      {item.label}
                    </Button>
                  </Grid>
                ))}
              </Grid>
              <ComingSoon
                open={openComingSoon}
                onClose={() => setOpenComingSoon(false)}
              />
            </Box>

            <Box p={2} hidden={tab !== 1}>
              {loadingTransactions ? (
                <Typography color="#ffffff">Loading transactions...</Typography>
              ) : transactions.length === 0 ? (
                <Typography color="#0b0a0a">
                  No recent transactions found.........
                </Typography>
              ) : (
                
                <Box
                  sx={{
                    maxHeight: { xs: 150, md: 200 },
                    overflowY: "auto",
                    "&::-webkit-scrollbar": { width: "4px" },
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "11px",
                    }}
                  >
                    <thead>
                      <tr>
                        {["Date", "Type", "Cr", "Dr", "Bal", "Status"].map(
                          (h) => (
                            <th
                              key={h}
                              style={{
                                padding: "4px",
                                fontSize: "10px",
                                textAlign: "left",
                              }}
                            >
                              {h}
                            </th>
                          ),
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.slice(0, 2).map((txn) => (
                        <tr key={txn.ID}>
                          <td style={{ padding: "4px" }}>
                            {formatDateOnly(txn.TrxnDate)}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              maxWidth: "80px",
                              overflow: "hidden",
                            }}
                          >
                            {txn.TransactionType}
                          </td>
                          <td style={{ color: "#22c55e", padding: "4px" }}>
                            {txn.Credit ? `₹${txn.Credit}` : "-"}
                          </td>
                          <td style={{ color: "#f44336", padding: "4px" }}>
                            {txn.Debit ? `₹${txn.Debit}` : "-"}
                          </td>
                          <td style={{ padding: "4px" }}>₹{txn.Balance}</td>
                          <td style={{ padding: "4px" }}>
                            <span
                              style={{
                                fontSize: "9px",
                                padding: "2px 6px",
                                borderRadius: "10px",
                                background:
                                  txn.TrxnStatus?.toLowerCase() === "success"
                                    ? "#22c55e"
                                    : "#f44336",
                                color: "#fff",
                              }}
                            >
                              {txn.TrxnStatus}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div style={{ textAlign: "right", marginTop: "6px" }}>
                    <span
                      style={{
                        fontSize: "11px",
                        color: "#16a34a",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigate("/profile-settings/transactionhistory")
                      }
                    >
                      View All →
                    </span>
                  </div>
                </Box>
              )}
            </Box>
          </Card>
        </Grid>
      </Grid>

      <Dialog
        open={openLedgerInfo}
        onClose={() => setOpenLedgerInfo(false)}
        PaperProps={{
          sx: {
            borderRadius: 4,
            p: 3,
            width: 420,
            background: isDark
              ? "linear-gradient(180deg, #0f1a29, #132237)"
              : "linear-gradient(180deg, #ffffff, #f9fafb)",
          },
        }}
      >
        <IconButton
          onClick={() => setOpenLedgerInfo(false)}
          sx={{ position: "absolute", top: 12, right: 12 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography fontWeight={700} fontSize={18} mb={1}>
          Wallet Ledger Balance
        </Typography>
        {subWallet ? (
          <Box>
            {[
              { label: "Wallet Balance", value: subWallet.General },
              { label: "Food Balance", value: subWallet.Food },
              { label: "Fuel Balance", value: subWallet.Fuel },
              { label: "Telecom Balance", value: subWallet.Telecom },
            ].map((item) => (
              <Box
                key={item.label}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 1,
                  p: 1,
                  borderRadius: 1,
                  background: isDark ? "#0f1a29" : "#f4f6f8",
                }}
              >
                <Typography fontSize={14}>{item.label}</Typography>
                <Typography fontSize={14} fontWeight={600}>
                  ₹ {item.value}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography fontSize={14} color="text.secondary">
            Loading wallet details...
          </Typography>
        )}
        <Button
          fullWidth
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            color: "white",
            bgcolor: "#16a34a",
            "&:hover": { bgcolor: "#15803d" },
          }}
          onClick={() => setOpenLedgerInfo(false)}
        >
          Got it
        </Button>
      </Dialog>

      <Secondhaldcontent billPaymentRef={billPaymentRef} />
    </>
  );
}
